import * as React from 'react';
import {
    Alert, Box, Button, Chip, CircularProgress, Paper, Stack, Table, TableBody,
    TableCell, TableContainer, TableHead, TableRow, Typography
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { FgsManagement } from '../../controllers';
import { TokenValidator } from '../../utils';

export default function ShippingOverview() {
    const [rows, setRows] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [message, setMessage] = React.useState(null);

    const load = React.useCallback(async () => {
        setLoading(true);
        const token = await TokenValidator.GetInternalUser();
        const response = await FgsManagement.ShippingOverview(token);
        setLoading(false);
        if (!response || !response.success) {
            setMessage(response ? response.message : 'Unable to load shipping configuration');
            return;
        }
        setRows(response.result.rows || []);
        setMessage(null);
    }, []);

    React.useEffect(() => { load(); }, [load]);

    return <Box>
        {message && <Alert severity='error' sx={{mb: 2}}>{message}</Alert>}
        <Alert severity='info' sx={{mb: 2}}>
            Read-only view of the shipping-label path derived from active Shared Box groups. Clients outside an active group use the Single label flow automatically.
        </Alert>
        <Stack direction='row' justifyContent='space-between' alignItems='center' sx={{mb: 2}}>
            <Box>
                <Typography variant='h6'>Shipping label routing</Typography>
                <Typography color='text.secondary'>Shared box or Single by client</Typography>
            </Box>
            <Button startIcon={<RefreshIcon />} onClick={load} disabled={loading}>Refresh</Button>
        </Stack>
        <TableContainer component={Paper}><Table size='small'>
            <TableHead><TableRow>
                <TableCell>Client</TableCell><TableCell>Products</TableCell><TableCell>Shipping type</TableCell>
                <TableCell>Label header</TableCell><TableCell>Configuration source</TableCell>
            </TableRow></TableHead>
            <TableBody>
                {loading && <TableRow><TableCell colSpan={5} align='center'><CircularProgress size={28} /></TableCell></TableRow>}
                {!loading && rows.map(row => <TableRow key={row.key} hover>
                    <TableCell>{row.client}</TableCell>
                    <TableCell>{row.products.length ? row.products.join(', ') : '—'}</TableCell>
                    <TableCell><Chip size='small' color={row.shippingType === 'shared_box' ? 'primary' : 'default'} label={row.shippingType === 'shared_box' ? 'Shared box' : 'Single'} /></TableCell>
                    <TableCell>{row.labelHeader}</TableCell>
                    <TableCell>{row.source === 'shared_ship_box' ? `Active shared_ship_box${row.sharedBoxIds.length ? ` #${row.sharedBoxIds.join(', #')}` : ''}` : 'Default Single fallback'}</TableCell>
                </TableRow>)}
                {!loading && !rows.length && <TableRow><TableCell colSpan={5} align='center'>No active FGS clients found.</TableCell></TableRow>}
            </TableBody>
        </Table></TableContainer>
    </Box>;
}
